export const CONTENT_KEYS = {
  all: ['content'] as const,
  catalog: (filters?: Record<string, unknown>) => [...CONTENT_KEYS.all, 'catalog', filters ?? {}] as const,
} as const;
